<div mat-dialog-title>
    <div class="row">
        <h4 class="col-8">{{data.title}}</h4>
        <span class="col-4 text-right">
            <button mat-icon-button class="close-icon" [mat-dialog-close]="false">
                <i class="fas fa-times"></i>
            </button>
        </span>
    </div>
</div>
<div mat-dialog-content>
    <div *ngIf="checkType()">
        <object class="pdf-viewer" *ngIf="file; else loadFailed" [data]="file" style="min-height: 500px; min-width: 1000px">
        </object>
        <ng-template #loadFailed><p class="text-muted"><i>Unable to load...</i></p></ng-template>
    </div>
    <div *ngIf="!checkType()" class="notViewable">
        <p><i>Sorry, this file is not viewable in the browser. Please use the download button below to download and view the file.</i></p>
    </div>
</div>
<div class="actionBtns text-right">
    <a mat-raised-button color="primary" class="bottom-button" [href]="file" [download]="data.filename" (click)="dialogRef.close()" cdkfocusinitial>Download</a>
    <button mat-raised-button class="bottom-button" (click)="dialogRef.close()">Cancel</button>
</div>
